var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contaier"},[_c('div',{staticClass:"box md:flex md:justify-between"},[_c('a',{attrs:{"href":"tel:852 7072 8028"}},[_vm._v("WhatsApp: +852 7072 8028")]),_c('p',[_vm._v("© iCAUR Hong Kong 2026 All rights reserved")])])])
}]

export { render, staticRenderFns }